import Entity from '../../../../core/domain/entity';
import UniqueEntityID from '../../../../core/domain/unique_entity_id';

export interface InAppPurchaseProps {
  paymentIntentId: string;
  customerId: string;
  dietitianId: string | undefined;
  productId: string;
  invoiceId: string | undefined;
  description: string;
  amount: number;
  currency: string;
  createdAt: Date;
}

export class InAppPurchaseId extends Entity<unknown> {
  private constructor(id?: UniqueEntityID) {
    super(null, id);
  }

  public static create(id?: UniqueEntityID): InAppPurchaseId {
    return new InAppPurchaseId(id);
  }
}

export class InAppPurchase extends Entity<InAppPurchaseProps> {
  get inAppPurchaseId(): InAppPurchaseId {
    return InAppPurchaseId.create(this.id);
  }

  get paymentIntentId(): string {
    return this.props.paymentIntentId;
  }

  get customerId(): string {
    return this.props.customerId;
  }

  get dietitianId(): string | undefined {
    return this.props.dietitianId;
  }

  get productId(): string {
    return this.props.productId;
  }

  get invoiceId(): string | undefined {
    return this.props.invoiceId;
  }

  get description(): string {
    return this.props.description;
  }

  get amount(): number {
    return this.props.amount;
  }

  get currency(): string {
    return this.props.currency;
  }

  get createdAt(): Date {
    return this.props.createdAt;
  }

  private constructor(props: InAppPurchaseProps, id?: UniqueEntityID) {
    super(props, id);
  }

  copyWith(props: InAppPurchaseProps): InAppPurchase {
    return InAppPurchase.create(
      {
        ...this.props,
        ...props,
      },
      this.id,
    );
  }

  public static create(
    props: InAppPurchaseProps,
    id?: UniqueEntityID,
  ): InAppPurchase {
    return new InAppPurchase(props, id);
  }
}
